// Utilitaire d'export CSV client-side (UTF-8 BOM + séparateur `;` compatible Excel/Numbers FR).

const BOM = "\uFEFF";

function escapeCell(value) {
  if (value === null || value === undefined) return "";
  const str = String(value);
  // Si la valeur contient `;`, `"`, ou un saut de ligne, on l'encadre de guillemets et on double les `"`.
  if (/[;"\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

/**
 * Génère et déclenche le téléchargement d'un fichier CSV.
 *
 *   downloadCsv({
 *     filename: "sites",
 *     columns: [
 *       { key: "name", label: "Nom" },
 *       { key: "type", label: "Type" },
 *       { key: "address", label: "Adresse" },
 *     ],
 *     rows: filteredList,
 *   });
 *
 * Le nom de fichier est suffixé par un horodatage YYYY-MM-DD_HHmm.
 */
export function downloadCsv({ filename, columns, rows }) {
  if (!Array.isArray(columns) || columns.length === 0) return;

  const header = columns.map((c) => escapeCell(c.label)).join(";");
  const body = (rows || []).map((row) =>
    columns.map((c) => {
      const value = typeof c.value === "function" ? c.value(row) : row?.[c.key];
      return escapeCell(value);
    }).join(";"),
  );

  const csv = BOM + [header, ...body].join("\r\n");

  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const stamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}`;
  const safeName = String(filename || "export").replace(/[^a-zA-Z0-9_-]/g, "_");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${safeName}_${stamp}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
